// extracted by mini-css-extract-plugin
export default {"container":"JlZmm","retry":"BXyoD","icon":"TPcfF","text":"UE1ng","title":"FKuSv"};